// extracted by mini-css-extract-plugin
module.exports = {"dottedCircle":"Animacion_dottedCircle__ibjcS","test":"Animacion_test__U0YCK"};